import GoToBackArrow from "../../components/GoToBackArrow";
import Details from "../../components/DifficultComponents/Details";
import ServiceComponent from "../../components/DifficultComponents/ServiceComponent";
import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {API_BASE_URL} from "../../config";
import ErrorAlert from "../../components/ErrorAlert";
import Loading from "../../components/Loading";

const ManageBooking = () => {
    localStorage.setItem('mode', 'edit');

    const { order_id } = useParams();
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);
    const [ order, setOrder ] = useState();

    useEffect(() => {
        if(!order_id) {
            setError('Не указан заказ!')
            return;
        }

        (async () => {
            setLoading(true);
            setError(null);
            try {
                const resp = await fetch(`${API_BASE_URL}/api/order/${order_id}/`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    }
                })

                const data = await resp.json();

                if(resp.ok) {
                    const order = data;
                    setOrder(order)

                    localStorage.setItem('orderId', order.id)
                    localStorage.setItem('serviceId', order.service_id)
                    localStorage.setItem('expertId', order.specialist_id)
                    localStorage.setItem('title', order.service)
                    localStorage.setItem('price', order.service_price)
                    localStorage.setItem('duration', order.service_duration)
                    localStorage.setItem('expert', order.specialist);
                    localStorage.setItem('time', order.start_time);
                    localStorage.setItem('day', order.date);

                } else if(data.error) {
                    setError(data.error);
                } else {
                    setError('Упс... Что-то пошло не так. Попробуйте позже.');
                }

                setLoading(false);

            } catch (e) {
                setError(e.toString());
                setLoading(false);
            }
        })()
    }, [ order_id ]);

    const title = order?.service || '';
    const duration = order?.service_duration || '';
    const price = order?.service_price || '';

    return (
        <div className="order_details_page page_bg">
            <GoToBackArrow backUrl={'/order-list'} />

            <div className="content_title">
                <span>Детали записи</span>
            </div>

            {loading ? <Loading/> : (
                error ? <ErrorAlert>{error}</ErrorAlert> : (
                    <div className="order_details_list">
                        <Details type={"expert"} img={"pencil"} />
                        <Details type={"time"} img={"pencil"} />

                        <ServiceComponent
                            title={title}
                            duraion={duration}
                            price={price}
                            chosenService={{title}}
                            img={"pencil"}
                        />
                    </div>
                )
            )}

        </div>
    )
}

export default ManageBooking;